/**
 * JYTR — display name filter for the Collector's Vault.
 * Blocks offensive display names before they're submitted, in:
 *   - the Founders Edition "List me on the Collectors wall" opt-in (product page, Add to cart)
 *   - the Founders List request form (Collector's Vault page, "Add/Change my name")
 * Catches look-alike spellings (f*ck → 4/@ for a, 0 for o, 1 for i, 3 for e, 5/$ for s…),
 * stretched letters (fuuuck), accents, and spaced/dotted letters (f.u.c.k).
 * This is a first line of defence only — names are still checked by hand before they appear.
 *
 * To add a word:
 *   ANYWHERE — blocked even inside another word (only for words that never appear inside normal names).
 *   WHOLE    — blocked only as a word on its own, so real names aren't caught
 *              (e.g. "ass" is blocked, but "Cassandra" is fine; "cock" is blocked, "Hancock" is fine).
 *   ALLOW    — real words or names that happen to contain a blocked word (e.g. Matsushita, therapist).
 */
(function () {
  var ANYWHERE = [
    'fuck', 'fukk', 'fukin', 'fck', 'shit', 'cunt', 'bitch', 'wank', 'twat', 'bollock', 'bastard', 'whore', 'slut',
    'dildo', 'porn', 'pussy', 'jizz', 'arsehol', 'asshol', 'bellend', 'clunge', 'tosser', 'piss', 'retard',
    'spastic', 'nigger', 'nigga', 'faggot', 'hitler', 'rapist', 'paedo', 'pedophil', 'motherf'
  ];
  var WHOLE = [
    'ass', 'arse', 'cock', 'dick', 'prick', 'knob', 'tit', 'tits', 'titty', 'boob', 'cum', 'sex', 'shag',
    'minge', 'fag', 'fags', 'rape', 'nazi', 'heil', 'kkk', 'paki', 'coon', 'spic', 'wog', 'chink', 'kike',
    'tranny', 'nonce', 'pedo', 'fuk', 'fuker', 'damn', 'crap', 'sod', 'bugger', 'balls', 'nob', 'wtf', 'stfu'
  ];
  var ALLOW = ['shiitake', 'matsushita', 'yamashita', 'kinoshita', 'therapist', 'therapists', 'scunthorpe', 'penistone', 'cockermouth'];

  // Each letter may be stretched (fuuuck), but a double letter must stay at least double (ass ≠ as).
  function toPattern(word) {
    return word.replace(/(.)\1*/g, function (run, ch) { return ch + (run.length > 1 ? '{' + run.length + ',}' : '+'); });
  }
  var anywhereRe = new RegExp('(' + ANYWHERE.map(toPattern).join('|') + ')');
  var wholeRe = new RegExp('^(' + WHOLE.map(toPattern).join('|') + ')(e?s|z)?$');

  var LEET = { '0': 'o', '3': 'e', '4': 'a', '5': 's', '7': 't', '8': 'b', '9': 'g', '@': 'a', '$': 's', '!': 'i', '|': 'i', '+': 't' };

  function variants(raw) {
    var base = String(raw || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    base = base.replace(/[0345789@$!|+]/g, function (c) { return LEET[c] || c; });
    // "1" can stand for i or l; "ph" can stand for f
    var out = base.indexOf('1') === -1 ? [base] : [base.replace(/1/g, 'i'), base.replace(/1/g, 'l')];
    if (base.indexOf('ph') !== -1) out = out.concat(out.map(function (t) { return t.replace(/ph/g, 'f'); }));
    return out;
  }

  function wordsOf(text) {
    var tokens = text.split(/[^a-z]+/).filter(Boolean);
    var words = tokens.slice();
    // Rejoin runs of single letters: "f u c k" / "f.u.c.k" → "fuck"
    var run = '';
    tokens.concat(['..']).forEach(function (t) {
      if (t.length === 1) { run += t; } else { if (run.length > 1) words.push(run); run = ''; }
    });
    return words;
  }

  function isOffensive(raw) {
    return variants(raw).some(function (text) {
      return wordsOf(text).some(function (w) {
        if (ALLOW.indexOf(w) !== -1) return false;
        return anywhereRe.test(w) || wholeRe.test(w);
      });
    });
  }

  var MESSAGE = 'Please choose a different display name.';

  if (typeof window === 'undefined') { module.exports = { isOffensive: isOffensive }; return; }
  window.JytrNameFilter = isOffensive;

  // Founders Edition product page — check before the Add to cart handler runs
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('#foundersAddToCart')) return;
    var optIn = document.getElementById('collectorOptIn');
    var input = document.getElementById('collectorName');
    var error = document.getElementById('collectorNameError');
    if (!optIn || !optIn.checked || !input || !isOffensive(input.value)) return;
    e.preventDefault();
    e.stopPropagation();
    if (error) {
      if (!error.dataset.defaultText) error.dataset.defaultText = error.textContent;
      error.textContent = MESSAGE;
      error.style.display = 'block';
    }
    input.classList.add('invalid');
    input.focus();
  }, true);

  document.addEventListener('input', function (e) {
    if (e.target.id !== 'collectorName') return;
    var error = document.getElementById('collectorNameError');
    if (error && error.dataset.defaultText) error.textContent = error.dataset.defaultText;
  });

  // Founders List request form — check before the verification code is checked
  document.addEventListener('submit', function (e) {
    if (e.target.id !== 'foundersListRequest') return;
    var type = document.getElementById('reqType');
    var input = document.getElementById('reqName');
    var result = document.getElementById('reqResult');
    if (!input || (type && type.value.indexOf('Remove') === 0) || !isOffensive(input.value)) return;
    e.preventDefault();
    e.stopPropagation();
    if (result) { result.className = 'verify-result is-bad'; result.textContent = MESSAGE; }
    input.focus();
  }, true);
})();
